VIDEO_TAB_VALUE